import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { SeoLink } from 'dibs-elements/exports/SeoLink.tsx';
import { SEGMENTS } from 'dibs-constants/exports/uriConstants.ts';
import { useSbSelector } from '../../reducers/useSbSelector.ts';

import {
    checkRewardedSeller,
    checkTradeUserUnderTopLevelLoyaltyTiers,
} from 'dibs-buyer-layout/exports/sellerBrandingHelpers.ts';

import { type SbSharedStorefrontLink_browseContentModule$data } from './__generated__/SbSharedStorefrontLink_browseContentModule.graphql.ts';
import { type SbSharedStorefrontLink_user$data } from './__generated__/SbSharedStorefrontLink_user.graphql.ts';

import styles from './SbSharedStorefrontLink.scss';

type Props = {
    user: SbSharedStorefrontLink_user$data;
    browseContentModule: SbSharedStorefrontLink_browseContentModule$data;
};

export const SbSharedStorefrontLinkBase: FC<Props> = ({ browseContentModule, user }) => {
    const seller = browseContentModule.seller;
    const company = seller?.sellerProfile?.company;

    const isClient = useSbSelector(state => state.relayVariables.variables.isClient);

    if (!seller || !company) {
        return null;
    }

    const shouldShowSellerDescription =
        checkRewardedSeller(seller) ||
        (isClient && checkTradeUserUnderTopLevelLoyaltyTiers(user || null));

    if (!shouldShowSellerDescription) {
        return null;
    }

    const urlLabel = seller.sellerPreferences?.urlLabel;
    const isLinkable = !!urlLabel && seller.liveStorefrontProfile?.status === 'LIVE';
    const path = isLinkable ? `/${SEGMENTS.SELLER}/${urlLabel}/` : null;

    return (
        <div className={styles.wrapper}>
            (
            <FormattedMessage
                id="SbSharedStorefrontLink.bioProvidedBy"
                defaultMessage="Biography provided by"
            />{' '}
            <SeoLink
                linkData={{
                    path,
                    isLinkable,
                }}
                dataTn="bio-seller-link"
            >
                {company}
            </SeoLink>
            )
        </div>
    );
};
